// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");

function EmailVerificationMessage(props) {
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "email");
  var email = x !== undefined && x !== "" ? x : "your email";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                        children: [
                                          JsxRuntime.jsx("h1", {
                                                children: "We have sent a verification email to " + email,
                                                className: "text-darksilver text-base font-normal px-4"
                                              }),
                                          JsxRuntime.jsx("p", {
                                                children: "Click on the link sent to your email to complete verification.",
                                                className: "text-darkcharcoal text-2xl font-medium px-4"
                                              })
                                        ]
                                      }),
                                  className: "text-center flex flex-col gap-2"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: "Already verified?",
                                          className: "text-dimgray font-normal text-sm mr-1"
                                        }),
                                    JsxRuntime.jsx("a", {
                                          children: "Log in",
                                          className: "text-black font-normal text-sm",
                                          href: "/accounts/sign_in"
                                        })
                                  ],
                                  className: "flex items-center"
                                })
                          ],
                          className: "flex items-center justify-center flex-col gap-8"
                        }),
                    className: "flex items-center justify-center w-full h-4/5"
                  }),
              className: "flex h-full pt-3"
            });
}

var make = EmailVerificationMessage;

exports.make = make;
/* querystringify Not a pure module */
